// import React, { useRef, useEffect } from "react";
// import jsPDF from "jspdf";
// import { calculatorNotes } from "./CalculatorNotes";
// import backgroundImg from "../../../Assets/Pdf/pdf_bg.jpeg";

// const DownloadEstimatePDF = ({
//   calculatorName,
//   grade,
//   type,
//   distance,
//   pumping,
//   result,
//   phone,
//   checklist,
//   handleClear,
//   score,
//   autoDownload = false,
//   onAutoDownloadComplete,
// }) => {
//   const hasAutoDownloaded = useRef(false);

//   const downloadPDF = async () => {
//     const doc = new jsPDF();

//     // --- Load background image ---
//     const bgImage = new Image();
//     bgImage.src = backgroundImg;
//     await new Promise((resolve) => {
//       bgImage.onload = resolve;
//     });

//     const addBackground = () => {
//       doc.addImage(
//         bgImage,
//         "JPEG",
//         0,
//         0,
//         doc.internal.pageSize.width,
//         doc.internal.pageSize.height,
//       );
//     };

//     addBackground();

//     // --- Content (compressed spacing) ---
//     let y = 47; // reduced top margin

//     // Title
//     doc.setFontSize(16); // was 20
//     doc.text(calculatorName, 105, y, { align: "center" });
//     y += 6; // was 8

//     doc.setFontSize(12); // was 14
//     doc.text("Concrete Estimate Report", 105, y, { align: "center" });
//     y += 8; // was 15

//     doc.setFontSize(10);
//     doc.text(`Generated: ${new Date().toLocaleString()}`, 15, y);
//     y += 8; // was 15

//     // --- Readiness Status ---
//     let status = "Ready";
//     if (score < 70) status = "High Risk";
//     else if (score < 90) status = "Minor Risks";

//     doc.setFontSize(12); // was 15
//     doc.text("Readiness Status", 15, y);
//     y += 6; // was 10

//     doc.setFontSize(10); // was 12
//     doc.text(`Score : ${score}/100`, 20, y);
//     y += 5; // was 8
//     doc.text(`Status : ${status}`, 20, y);
//     y += 5; // was 10

//     // ----- TWO‑COLUMN SECTION (Input Details & Estimate) -----
//     const leftX = 20;
//     const rightX = 120;
//     let leftY = y + 4;
//     let rightY = y + 4;

//     // Left column
//     doc.setFontSize(12); // was 14
//     doc.text("Input Details", leftX, leftY);
//     leftY += 8; // was 10
//     doc.setFontSize(10); // was 12
//     const leftItems = [
//       `Grade : ${grade}`,
//       `Type : ${type}`,
//       `Distance : ${distance} km`,
//       `Pumping : ${pumping ? "Yes" : "No"}`,
//     ];
//     leftItems.forEach((item) => {
//       doc.text(item, leftX + 5, leftY);
//       leftY += 6; // was 8
//     });

//     // Right column
//     // doc.setFontSize(12); // was 14
//     // doc.text("Estimate", rightX, rightY);
//     // rightY += 8;
//     // doc.setFontSize(10); // was 12
//     // const rightItems = [
//     //   `Concrete Price : Rs. ${result.mixturePrice}`,
//     //   `Transportation : Rs. ${result.distanceCost.toFixed(2)}`,
//     //   `Pumping Charge : Rs. ${result.pumpingCost}`,
//     //   `Operational Cost : Rs. 700`,
//     // ];
//     // rightItems.forEach((item) => {
//     //   doc.text(item, rightX + 5, rightY);
//     //   rightY += 6;
//     // });

//     // Grand total
//     doc.setFontSize(12); // was 14
//     doc.setFont(undefined, "bold");
//     doc.text(
//       `Grand Total : Rs. ${result.total.toFixed(0)}`,
//       rightX + 5,
//       rightY,
//     );
//     doc.setFont(undefined, "normal");

//     y = Math.max(leftY, rightY) + 10; // was 15

//     // ----- Checklist (only checked items) -----
//     const checkedItems = checklist
//       ? checklist.filter((item) => item.checked)
//       : [];
//     if (checkedItems.length > 0) {
//       doc.setFontSize(12); // was 14
//       doc.text("Checklist", 15, y);
//       y += 6; // was 10

//       doc.setFontSize(9); // was 12
//       checkedItems.forEach((item) => {
//         const text = `. ${item.label}`;
//         const lines = doc.splitTextToSize(text, 180);
//         if (y + lines.length * 5 > 270) {
//           doc.addPage();
//           addBackground();
//           y = 40;
//         }
//         doc.text(lines, 20, y);
//         y += lines.length * 5 + 1; // tighter
//       });
//       y += 4; // was 5
//     }

//     // ----- Important Notes (compressed) -----
//     doc.setFontSize(12); // was 14
//     doc.text("Important Notes", 15, y);
//     y += 6; // was 10

//     doc.setFontSize(10); // was 11
//     calculatorNotes.forEach((note) => {
//       const lines = doc.splitTextToSize(`• ${note}`, 170);
//       if (y + lines.length * 5 > 270) {
//         doc.addPage();
//         addBackground();
//         y = 40;
//       }
//       doc.text(lines, 20, y);
//       y += lines.length * 5 + 1;
//     });

//     y += 6; // was 10

//     // ----- Enquiry -----
//     doc.setFontSize(12); // was 14
//     doc.text("For Enquiry", 15, y);
//     y += 6; // was 8
//     doc.setFontSize(10); // was 12
//     doc.text(phone, 20, y);

//     // --- Save PDF ---
//     doc.save(`${calculatorName}.pdf`);
//     if (handleClear) {
//       handleClear();
//     }
//   };

//   // Auto‑download effect
//   useEffect(() => {
//     if (autoDownload && !hasAutoDownloaded.current) {
//       hasAutoDownloaded.current = true;
//       downloadPDF().then(() => {
//         if (onAutoDownloadComplete) {
//           onAutoDownloadComplete();
//         }
//       });
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [autoDownload, onAutoDownloadComplete]);

//   // Manual download button
//   return (
//     <button
//       onClick={downloadPDF}
//       className="w-full bg-green-600 text-white py-3 rounded-xl hover:bg-green-700 transition"
//     >
//       📄 Download Estimate PDF
//     </button>
//   );
// };

// export default DownloadEstimatePDF;


import React, { useRef, useEffect } from "react";
import jsPDF from "jspdf";
import { calculatorNotes } from "./CalculatorNotes";
import backgroundImg from "../../../Assets/Pdf/pdf_bg.jpeg";

// Colors sampled from the approved one-page layout.
const STATUS_STYLES = {
  READY: { fill: [220, 252, 231], text: [21, 128, 61] },
  "MINOR RISKS": { fill: [254, 243, 199], text: [180, 83, 9] },
  "HIGH RISK": { fill: [254, 226, 226], text: [185, 28, 28] },
};

const ACCENT = [190, 24, 93]; // brand pink used for Grand Total + bullets
const TOTAL_FILL = [253, 242, 248];

const getStatusConfig = (score) => {
  if (score >= 90) {
    return {
      label: "READY",
      message: "Site conditions look good. Proceed with standard dispatch procedures.",
    };
  }
  if (score >= 70) {
    return {
      label: "MINOR RISKS",
      message:
        "A few items need attention — review the checklist below before confirming dispatch.",
    };
  }
  return {
    label: "HIGH RISK",
    message:
      "Score below 70 — walk through the checklist on this page with the site team before confirming dispatch.",
  };
};

const COMPANY_EMAIL = "sales@mixmasters.in";

const DownloadEstimatePDF = ({
  calculatorName,
  grade,
  type,
  distance,
  pumping,
  result,
  phone,
  checklist,
  handleClear,
  score,
  autoDownload = false,
  onAutoDownloadComplete,
}) => {
  const hasAutoDownloaded = useRef(false);

  const downloadPDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    const marginX = 15;
    const contentWidth = pageWidth - marginX * 2; // 180 on A4

    const bgImage = new Image();
    bgImage.src = backgroundImg;
    await new Promise((resolve) => {
      bgImage.onload = resolve;
    });

    const addBackground = () => {
      doc.addImage(bgImage, "JPEG", 0, 0, pageWidth, pageHeight);
    };

    addBackground();

    let y = 46;

    // Safety net only — with the compact spacing below and the checklist
    // now limited to ticked items, this should never trigger for a
    // standard estimate and everything stays on a single A4 page.
    const checkPageBreak = (neededHeight) => {
      if (y + neededHeight > pageHeight - 15) {
        doc.addPage();
        addBackground();
        y = 40;
      }
    };

    // ---------------------------------------------------------------
    // Title + generated timestamp
    // ---------------------------------------------------------------
    doc.setTextColor(20, 20, 20);
    doc.setFont(undefined, "bold");
    doc.setFontSize(15);
    doc.text(calculatorName, marginX, y);
    y += 4;

    doc.setFont(undefined, "italic");
    doc.setFontSize(8);
    doc.setTextColor(110, 110, 110);
    // doc.text(`Generated: ${new Date().toLocaleString()}`, marginX, y);
    y += 5;

    doc.setFont(undefined, "normal");
    doc.setTextColor(20, 20, 20);

    // ---------------------------------------------------------------
    // Readiness Status — score box + filled status callout
    // ---------------------------------------------------------------
    doc.setFont(undefined, "bold");
    doc.setFontSize(10.5);
    doc.text("Readiness Status", marginX, y);
    y += 3;

    const statusConfig = getStatusConfig(score);
    const statusStyle = STATUS_STYLES[statusConfig.label];
    const leftBoxW = 40;
    const boxGap = 4;
    const rightBoxX = marginX + leftBoxW + boxGap;
    const rightBoxW = contentWidth - leftBoxW - boxGap;

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    const messageLines = doc.splitTextToSize(statusConfig.message, rightBoxW - 12);
    const boxHeight = Math.max(20, 11 + messageLines.length * 3.6);

    // Score box — plain, bordered only
    doc.setDrawColor(190, 190, 190);
    doc.setLineWidth(0.25);
    doc.rect(marginX, y, leftBoxW, boxHeight);

    doc.setFontSize(7.5);
    doc.setTextColor(130, 130, 130);
    doc.text("Score", marginX + leftBoxW / 2, y + 5, { align: "center" });

    doc.setFont(undefined, "bold");
    doc.setFontSize(17);
    doc.setTextColor(20, 20, 20);
    doc.text(String(score), marginX + leftBoxW / 2, y + 10, { align: "center" });

    doc.setFont(undefined, "normal");
    doc.setFontSize(7.5);
    doc.setTextColor(130, 130, 130);
    doc.text("/100", marginX + leftBoxW / 2, y + 14, { align: "center" });

    // Status box — filled callout
    doc.setFillColor(...statusStyle.fill);
    doc.rect(rightBoxX, y, rightBoxW, boxHeight, "F");

    doc.setFont(undefined, "bold");
    doc.setFontSize(9.5);
    doc.setTextColor(...statusStyle.text);
    doc.text(`STATUS: ${statusConfig.label}`, rightBoxX + 4, y + 6);

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    doc.text(messageLines, rightBoxX + 4, y + 11.5);

    y += boxHeight + 6;
    doc.setTextColor(20, 20, 20);

    // ---------------------------------------------------------------
    // Input Details (plain grid, divider lines — no box)
    // ---------------------------------------------------------------
    doc.setFont(undefined, "bold");
    doc.setFontSize(10.5);
    doc.text("Input Details", marginX, y);
    y += 4;

    doc.setDrawColor(220, 220, 220);
    doc.setLineWidth(0.2);
    doc.line(marginX, y, marginX + contentWidth, y);
    y += 5;

    const col1X = marginX;
    const col2X = marginX + 95;

    doc.setFontSize(8);
    doc.setFont(undefined, "normal");
    doc.setTextColor(130, 130, 130);
    doc.text("Grade", col1X, y);
    doc.text("Distance", col2X, y);
    doc.setFont(undefined, "bold");
    doc.setTextColor(20, 20, 20);
    doc.text(String(grade || "-"), col1X + 16, y);
    doc.text(`${distance || 0} km`, col2X + 18, y);
    y += 4;

    doc.setFont(undefined, "normal");
    doc.setTextColor(130, 130, 130);
    doc.text("Type", col1X, y);
    doc.text("Pumping", col2X, y);
    doc.setFont(undefined, "bold");
    doc.setTextColor(20, 20, 20);
    doc.text(String(type || "-"), col1X + 16, y);
    doc.text(pumping ? "Yes" : "No", col2X + 18, y);
    y += 4;

    doc.setDrawColor(220, 220, 220);
    doc.line(marginX, y, marginX + contentWidth, y);
    y += 8;

    // Grand Total — filled callout bar, full width
    doc.setFont(undefined, "normal");
    doc.setFontSize(7.5);
    const gstNoteLines = doc.splitTextToSize(
      "GST extra as applicable. Final billing is based on actual dispatch quantity.",
      contentWidth - 10
    );
    const totalBarHeight = 8 + gstNoteLines.length * 3.4;

    doc.setFillColor(...TOTAL_FILL);
    doc.rect(marginX, y, contentWidth, totalBarHeight, "F");

    doc.setFont(undefined, "bold");
    doc.setFontSize(11);
    doc.setTextColor(...ACCENT);
    doc.text("GRAND TOTAL", marginX + 5, y + 6);
    doc.text(`Rs. ${result.total.toFixed(0)}`, marginX + contentWidth - 5, y + 6, {
      align: "right",
    });

    doc.setFont(undefined, "italic");
    doc.setFontSize(7.5);
    doc.setTextColor(120, 120, 120);
    doc.text(gstNoteLines, marginX + 5, y + 10.5);

    y += totalBarHeight + 7;
    doc.setFont(undefined, "normal");
    doc.setTextColor(20, 20, 20);

    // ---------------------------------------------------------------
    // Site Readiness Checklist — 2-COLUMN GRID, ticked items only.
    // Items are paired row by row (item[0] & item[1] on row 1,
    // item[2] & item[3] on row 2, ...) so both columns line up and
    // each row only advances by its tallest wrapped label.
    // ---------------------------------------------------------------
    const checkedItems = checklist ? checklist.filter((item) => item.checked) : [];

    if (checkedItems.length > 0) {
      doc.setFont(undefined, "bold");
      doc.setFontSize(10.5);
      doc.text("Site Readiness Checklist", marginX, y);
      y += 4;

      doc.setDrawColor(220, 220, 220);
      doc.line(marginX, y, marginX + contentWidth, y);
      y += 4;

      doc.setFont(undefined, "normal");
      doc.setFontSize(8);

      const colGap = 8;
      const colWidth = (contentWidth - colGap) / 2;
      const leftColX = marginX;
      const rightColX = marginX + colWidth + colGap;

      for (let i = 0; i < checkedItems.length; i += 2) {
        const leftItem = checkedItems[i];
        const rightItem = checkedItems[i + 1];

        const leftLines = doc.splitTextToSize(leftItem.label, colWidth - 6);
        const rightLines = rightItem
          ? doc.splitTextToSize(rightItem.label, colWidth - 6)
          : [];

        const rowLines = Math.max(leftLines.length, rightLines.length);
        checkPageBreak(rowLines * 3.6 + 1.2);

        doc.setTextColor(...ACCENT);
        doc.text("•", leftColX + 1, y);
        doc.setTextColor(30, 30, 30);
        doc.text(leftLines, leftColX + 5, y);

        if (rightItem) {
          doc.setTextColor(...ACCENT);
          doc.text("•", rightColX + 1, y);
          doc.setTextColor(30, 30, 30);
          doc.text(rightLines, rightColX + 5, y);
        }

        y += rowLines * 3.6 + 1.2;
      }

      y += 4;
    }

    // ---------------------------------------------------------------
    // Important Notes
    // ---------------------------------------------------------------
    doc.setFont(undefined, "bold");
    doc.setFontSize(10.5);
    doc.setTextColor(20, 20, 20);
    doc.text("Important Notes", marginX, y);
    y += 4;

    doc.setDrawColor(220, 220, 220);
    doc.line(marginX, y, marginX + contentWidth, y);
    y += 4;

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    calculatorNotes.forEach((note) => {
      const lines = doc.splitTextToSize(note, contentWidth - 6);
      checkPageBreak(lines.length * 3.6 + 1);

      doc.setTextColor(...ACCENT);
      doc.text("•", marginX + 1, y);
      doc.setTextColor(30, 30, 30);
      doc.text(lines, marginX + 5, y);
      y += lines.length * 3.6 + 0.6;
    });

    y += 4;

    // ---------------------------------------------------------------
    // Validity
    // ---------------------------------------------------------------
    checkPageBreak(16);

    doc.setFont(undefined, "bold");
    doc.setFontSize(10.5);
    doc.text("Validity", marginX, y);
    y += 5;

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    doc.setTextColor(50, 50, 50);
    const validityLines = doc.splitTextToSize(
      "This estimate is valid for 7 days from the date of generation shown above, and is subject to site inspection, material availability, and confirmation at the time of booking.",
      contentWidth
    );
    doc.text(validityLines, marginX, y);
    y += validityLines.length * 3.8 + 6;

    // ---------------------------------------------------------------
    // For Enquiry
    // ---------------------------------------------------------------
    checkPageBreak(16);

    doc.setFont(undefined, "bold");
    doc.setFontSize(10.5);
    doc.setTextColor(20, 20, 20);
    doc.text("For Enquiry", marginX, y);
    y += 5;

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    doc.setTextColor(50, 50, 50);
    doc.text("Phone:", marginX, y);
    doc.setFont(undefined, "bold");
    doc.text(String(phone), marginX + 12, y);

    doc.setFont(undefined, "normal");
    doc.text("Email:", marginX + 90, y);
    doc.setFont(undefined, "bold");
    doc.text(COMPANY_EMAIL, marginX + 102, y);
    y += 4;

    doc.setDrawColor(220, 220, 220);
    doc.line(marginX, y, marginX + contentWidth, y);
    y += 4;

    // ---------------------------------------------------------------
    // Signature block
    // ---------------------------------------------------------------
    checkPageBreak(14);

    const sigColW = 75;
    doc.setDrawColor(60, 60, 60);
    doc.setLineWidth(0.25);
    doc.line(marginX, y, marginX + sigColW, y);
    doc.line(marginX + contentWidth - sigColW, y, marginX + contentWidth, y);

    doc.setFont(undefined, "normal");
    doc.setFontSize(7);
    doc.setTextColor(120, 120, 120);
    doc.text("Prepared By", marginX, y + 4);
    doc.text(
      "Customer Acknowledgement & Date",
      marginX + contentWidth - sigColW,
      y + 4
    );

    y += 8;

    // ---------------------------------------------------------------
    // Closing line
    // ---------------------------------------------------------------
    doc.setFont(undefined, "italic");
    doc.setFontSize(8.5);
    doc.setTextColor(...ACCENT);
    doc.text("Thank you for choosing Mix Masters RMC.", pageWidth / 2, y, {
      align: "center",
    });
    doc.setFont(undefined, "normal");

    doc.save(`${calculatorName}.pdf`);
    if (handleClear) {
      handleClear();
    }
  };

  useEffect(() => {
    if (autoDownload && !hasAutoDownloaded.current) {
      hasAutoDownloaded.current = true;
      downloadPDF().then(() => {
        if (onAutoDownloadComplete) {
          onAutoDownloadComplete();
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoDownload, onAutoDownloadComplete]);

  return (
    <button
      onClick={downloadPDF}
      className="w-full bg-green-600 text-white py-3 rounded-xl hover:bg-green-700 transition"
    >
      📄 Download Estimate PDF
    </button>
  );
};

export default DownloadEstimatePDF;